import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RelatorioService {

  constructor() { }

  public espacoEmBranco(){
    let coisa = {
      columns: [// gerado por
        
        {
          width:'*',
          text: ' ',
          fontSize: 10,
          alignment: 'center',
          bold:true
        }
      ]
     };
    return coisa;
  }

  public carregarImagemBase64(url){ // esse carregamento é compatível com Async Await
    
    return new Promise((resolve, reject) => {
      let img = new Image()
      img.onload = () => {
        let resultado;
        let canvas =  document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

          let ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          let dataURL = canvas.toDataURL("image/png");
    
           resultado = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
          
          resolve(resultado);
      }
      img.onerror = reject
      img.src = url;
    })
  
}

public imagemCentralizada(base){
  // let res = {
  //   columns: [  { width: '*',alignment: 'center', image:'data:image/jpeg;base64,'+base } ]
  // };

  let res = {
    image:'data:image/jpeg;base64,'+base,
    width: '400',
    alignment: 'center'
  }

  return res;
}

public imagemCentralizadaAssinatura(base){
  // let res = {
  //   columns: [  { width: '*',alignment: 'center', image:'data:image/jpeg;base64,'+base } ]
  // };

  let res = {
    image:'data:image/jpeg;base64,'+base,
    width: '230',
    alignment: 'center'
  }

  return res;
}

public miniSubtitulo(texto){// titullo alinhado no centro de tamanho um pouco menor
  let x = { 
    columns: [
      
      {
        width:'*',
        text: texto,
        fontSize: 12,
        alignment: 'center',
        bold:true
      }
    ]
  };

  return x;
}

public textoLimpo(texto){
  let d = { 
    columns: [
      
      {
        width:'*',
        text:texto,
        fontSize: 10,
        alignment: 'justify'
      }
    ]
  };
  return d;
}

public textoLimpoDireita(texto){
  let d = { 
    columns: [
      
      {
        width:'*',
        text:texto,
        fontSize: 10,
        alignment: 'right'
      }
    ]
  };
  return d;
}

public negrito(texto,tamanho){
  return	{text: texto, fontSize: tamanho, bold: true};
}

public textoLimpoDireitaGrande(texto){
  let d = { 
    columns: [
      
      {
        width:'*',
        text:texto,
        fontSize: 13,
        alignment: 'right'
      }
    ]
  };
  return d;
}


}
